import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function DeanDmSubmitForm() {
    const [isVerified, setIsVerified] = useState(false);
    const recaptcha = useRef();
    const category = [
        "ด้านวิชาการ/หลักสูตร",
        "ด้านบริการวิชาการ",
        "ด้านการวิจัย",
        "ด้านกิจกรรมนักศึกษา",
        "ด้านการสมัครศึกษาต่อ",
        "ด้านอื่นๆ",
    ];

    const handleVerify = (response) => {
        if (response) {
            setIsVerified(true);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isVerified) {
            console.log("form summited");
            document.getElementById("dean_dm").submit();
        } else {
            alert("submit alert Please verify");
        }
    };

    return (
        <>
            <div className="ddmHolder mx-auto bg-light rounded-4 p-5 col-xs-12 col-lg-10 col-xl-8 shadow">
                <form
                    id="dean_dm"
                    name="dean_dm"
                    action="https://faed.mju.ac.th/ddm/new.php"
                    method="POST"
                    onSubmit={handleSubmit}
                >
                    <div className="sectionTitle">
                        <p className="pageTitle">สายตรงคณบดี</p>
                        <p className="pageSubTitle">
                            คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม
                            <br />
                            มหาวิทยาลัยแม่โจ้
                        </p>
                        <p className="notice" style={{ fontSize: "1em" }}>
                            <span style={{ fontWeight: "bold" }}>
                                หมายเหตุ.
                            </span>{" "}
                            ท่านสามารถส่งข้อความ สอบถามข้อสงสัย
                            หรือแจ้งเรื่องร้องเรียน ถึงท่านคณบดีโดยตรง
                            โปรดใช้ถ้อยคำที่เหมาะสม
                            และโปรดตรวจสอบข้อความอย่างถี่ถ้วนอีกครั้ง
                            ก่อนกดส่งข้อความ
                        </p>
                    </div>
                    <hr className="mt-2" />
                    <div className="row row-cols-1 row-cols-md-2">
                        <div className="col mt-4">
                            <div className="form-group">
                                <label htmlFor="dm_username">
                                    ชื่อผู้ติดต่อ *
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="dm_username"
                                    id="dm_username"
                                    placeholder=""
                                    required
                                />
                            </div>
                        </div>
                        <div className="col mt-4">
                            <div className="form-group">
                                <label htmlFor="dm_usertype">ติดต่อในนาม</label>
                                <select
                                    className="form-control"
                                    name="dm_usertype"
                                    id="dm_usertype"
                                    required
                                >
                                    <option>บุคคลทั่วไป</option>
                                    <option>องค์กร/หน่วยงาน</option>
                                    <option>นักศึกษา มหาวิทยาลัยแม่โจ้</option>
                                    <option>บุคลากร มหาวิทยาลัยแม่โจ้</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-md-2">
                        <div className="col mt-4">
                            <div className="form-group">
                                <label htmlFor="dm_useremail">
                                    อีเมลที่ให้ติดต่อกลับ *
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="dm_useremail"
                                    id="dm_useremail"
                                    placeholder="name@example.com"
                                    required
                                />
                            </div>
                        </div>
                        <div className="col mt-4">
                            <div className="form-group">
                                <label htmlFor="dm_userphone">
                                    หรือ เบอร์โทรศัพท์ที่ให้ติดต่อกลับ
                                </label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    name="dm_userphone"
                                    id="dm_userphone"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-md-2">
                        <div className="col mt-4">
                            <div className="form-group">
                                <label htmlFor="dm_category">
                                    ประเด็นที่ต้องการติดต่อ...
                                </label>
                                <select
                                    className="form-control"
                                    name="dm_category"
                                    id="dm_category"
                                    required
                                >
                                    {category.length > 0
                                        ? category.map((item, key) => (
                                              <option key={item} value={item}>
                                                  {item}
                                              </option>
                                          ))
                                        : null}
                                </select>
                            </div>
                        </div>
                        <div className="col mt-4">
                            <div className="form-group">
                                <label htmlFor="dm_title">หัวเรื่อง</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="dm_title"
                                    id="dm_title"
                                    placeholder=""
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-group mt-3">
                        <label htmlFor="dm_memo">ข้อความ</label>
                        <textarea
                            className="form-control"
                            name="dm_memo"
                            id="dm_memo"
                            rows="8"
                            placeholder="ข้อความ...(สามารถแนบลิงก์ได้)"
                            required
                        ></textarea>
                    </div>
                    <input type="hidden" name="fst" value="form_dean_dm" />
                    <div className="form-group mt-3 text-center align-self-center">
                        <ReCAPTCHA
                            ref={recaptcha}
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                            onChange={handleVerify}
                        />
                    </div>
                    <div className="text-center">
                        <button
                            className="btn btn-outline-primary mt-4 px-5 shadow"
                            type="submit"
                        >
                            ส่งข้อความ
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}
